<div class="image-container">
  <img
    class="w-100 hero-image"
    [ngClass]="{ 'd-none d-md-block': data?.imageSmallPath }"
    [src]="data.imageIconPath"
    [alt]="data.imageAlt"
  />
  <img
    class="w-100 d-block d-md-none hero-image"
    *ngIf="data?.imageSmallPath"
    [src]="data?.imageSmallPath"
    [alt]="data.imageAlt"
  />
</div>
